import { z } from "zod";

// Imported first in main.tsx, before anything that builds a schema: route
// search schemas are created while imports evaluate. The Content Security
// Policy forbids eval, so zod must not try compiling validators with
// new Function (it would fall back, but the probe raises a CSP violation).
z.config({ jitless: true });
